import { useState, useEffect } from "react";
import { CouponTicket } from "@components/coupon-ticket";

/*
 * @name CouponWalletPage - 顯示優惠券頁面
 * 若要檢視無優惠券的畫面，請將 wallets 設為空陣列
 */

const CouponWalletPage = () => {
	// 定義 RWD 樣式
	const [containerClass, setContainerClass] = useState("");
	const [titleClass, setTitleClass] = useState("");
	const [emptyDescriptionClass, setEmptyDescriptionClass] = useState("");
	const [emptyImageClass, setEmptyImageClass] = useState("");
	const [ticketContainerClass, setTicketContainerClass] = useState("");
	// ---------------------------------------------------------------------------------

	const wallets = [];

	useEffect(() => {
		window.addEventListener("resize", handleResize);
		handleResize();

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	const handleResize = () => {
		if (window.innerWidth > 640) {
			setContainerClass("px-[59px] flex flex-col items-center");
			setTitleClass("w-[141px] h-auto");
			setEmptyDescriptionClass("w-[209px] h-auto mt-8");
			setEmptyImageClass("h-auto w-[163px] mt-8");
			setTicketContainerClass("mt-7 w-full space-y-7");
		} else {
			setContainerClass("px-[9vw] flex flex-col items-center");
			setTitleClass("w-[22vw] h-auto");
			setEmptyDescriptionClass("w-[33vw] h-auto mt-[5vw]");
			setEmptyImageClass("h-auto w-[25vw] mt-[5vw]");
			setTicketContainerClass("mt-[4vw] w-full space-y-[4vw]");
		}
	};

	return (
		<div className={containerClass}>
			<img
				alt={"title"}
				className={titleClass}
				src={window.assetUrl(
					"/images/liff/coupon-wallet-page/title.png",
				)}
			/>
			{wallets.length > 0 ? (
				<div className={ticketContainerClass}>
					{wallets.map((coupon, index) => (
						<CouponTicket
							key={index}
							coupon={coupon}
							needExchange={coupon.needExchange}
						/>
					))}
				</div>
			) : (
				<div className={"flex flex-col items-center justify-center"}>
					<img
						alt={"empty-description"}
						className={emptyDescriptionClass}
						src={window.assetUrl(
							"/images/liff/coupon-wallet-page/empty-description.png",
						)}
					/>
					<img
						alt={"empty"}
						className={emptyImageClass}
						src={window.assetUrl(
							"/images/liff/coupon-wallet-page/empty.png",
						)}
					/>
				</div>
			)}
		</div>
	);
};

export default CouponWalletPage;
